import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export function renderButtonWidget(context, widget, parent) {

    const el = context.document.createElement("a");
    el.classList.add("widget", "button_widget");

    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getButtonStyles(widget)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    const span = context.document.createElement("span");
    span.innerHTML = widget.content || "";
    span.setAttribute("style", cssUtil.toStyleString(getAlignmentStyles(widget)));

    el.appendChild(span);
    parent.appendChild(el);
    return el;
}

function getButtonStyles(widget) {
    const styles = {};
    const p = widget?.properties?.desktop?.regular;
    if (!p) return styles;

    // font
    if (p.font?.family) styles["font-family"] = p.font.family;
    if (p.font?.fontSize) styles["font-size"] = cssUtil.px(p.font.fontSize);
    if (p.font?.color?.type === "solid") {
        styles["color"] = cssUtil.getCssColor(p.font.color);
    }
    if (p.font?.style?.bold) styles["font-weight"] = "bold";
    if (p.font?.style?.italic) styles["font-style"] = "italic";
    if (p.font?.style?.underline) styles["text-decoration"] = "underline";

    // background
    if (p.background) styles["background-color"] = p.background;
    if (p.background?.type === "solid") {
        styles["background-color"] = cssUtil.getCssColor(p.background);
    }

    // border
    const b = p.border;
    if (b) {
        styles["border-style"] = "solid";
        if (b.width) styles["border-width"] = cssUtil.px(b.width);
        const borderColor = b.color;
        if (borderColor?.type === "solid") {
            styles["border-color"] = cssUtil.getCssColor(borderColor);
        }

        const r = b.radius || {};
        if (r.topLeft) styles["border-top-left-radius"] = cssUtil.px(r.topLeft);
        if (r.topRight) styles["border-top-right-radius"] = cssUtil.px(r.topRight);
        if (r.bottomLeft) styles["border-bottom-left-radius"] = cssUtil.px(r.bottomLeft);
        if (r.bottomRight) styles["border-bottom-right-radius"] = cssUtil.px(r.bottomRight);
    }

    return styles;
}

function getAlignmentStyles(widget) {
    const styles = {};
    const align = widget?.properties?.desktop?.alignment;
    if (!align) return styles;

    if (align.position === "left") {
        styles.left = cssUtil.px(align.margin);
        styles.transform = "translateY(-50%)";
        styles["text-align"] = "left";
    }

    if (align.position === "right") {
        styles.right = cssUtil.px(align.margin);
        styles.transform = "translateY(-50%)";
        styles["text-align"] = "right";
    }

    return styles;
}